export default {
  Title: 'Kết quả thực hiện',
  ZoomOut: 'Phóng to',
  ZoomIn: 'Thu nhỏ',
  Button: {
    Close: 'Đóng',
    ExportExcel: 'Xuất Excel',
  },
};
